const copayOnboard = [
  "https://stgkippapps.blob.core.windows.net/img/Tutorial_Copay_1.png",
  "https://stgkippapps.blob.core.windows.net/img/Tutorial_Copay_2.png",
  "https://stgkippapps.blob.core.windows.net/img/Tutorial_Copay_3.png",
  "https://stgkippapps.blob.core.windows.net/img/Tutorial_Copay_4.png"
];

export default copayOnboard;
